<template>
  <ul class="nav nav-tabs profile-tab" role="tablist">
    <li class="nav-item">
      <router-link
        :to="{ name: 'setting' }"
        class="nav-link"
        :class="{ active: activeMenu == 'setting' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
      >
        Setting
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'profile' }"
        class="nav-link"
        :class="{ active: activeMenu == 'profile' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
      >
        Update Password
      </router-link>
    </li>
  </ul>
</template>


<script>
export default {
  name: "ProfileHeader",
  props: [
    'activeMenu'
  ],
};
</script>
